require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-financialinclusionpoweredbygenderparity.json") })
        }
      }, "path---insights-financialinclusionpoweredbygenderparity");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-financialinclusionpoweredbygenderparity!./.cache/json/insights-financialinclusionpoweredbygenderparity.json
// module id = 1109
// module chunks = 231608221292675